






























import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "Jira"
})
export default class Jira extends Vue {}
